import LegalBanner from "../../components/privacy-policy-page-components/legal-banner/LegalBanner.tsx";
import bannerImage from "/assets/images/why-opay-page-images/icon-about-feature-6.svg";
import GeneralTermsUpdatesSection
    from "../../components/general-terms-page-components/general-terms-updates-section/GeneralTermsUpdatesSection.tsx";
import {GeneralTermsUpdatesSectionConfig} from "../../configs/legal-pages/generalTermsUpdatesSection.ts";
import {GeneralTermsPageSectionsConfig} from "../../configs/legal-pages/generalTermsSections.ts";
import CustomHelmet from "../../components/helmet/CustomHelmet.tsx";
import LegalPageNumericListSections
    from "../../components/payment-terms-page-components/LegalPageNumericListSections.tsx";

const GeneralTermsPage = () => {
    return (
        <>
            <CustomHelmet title={'titles.general_terms'} />
            <LegalBanner heading={'general_terms'} image={bannerImage} />
            <GeneralTermsUpdatesSection config={GeneralTermsUpdatesSectionConfig}/>
            <ol className="opy-bg-white container opy-block">
                <LegalPageNumericListSections config={GeneralTermsPageSectionsConfig} />
            </ol>
        </>
    )
}

export default GeneralTermsPage;
